import { cloneElement } from 'react'
import {
  BooleanInput,
  Filter,
  sanitizeListRestProps,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  usePermissions,
} from 'react-admin'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { CustomBooleanField } from '../../components/Fields'
import { hasPermission, Permissions } from '../../Permissions'
import { BrokerQuickCreateButton } from '../Common/Brokers'
import { CTDatagrid } from '../CTDatagrid'
import CTList from '../List'
import { BROKER_STATUS_CHOICES } from './BrokerStatusTransitions'

const BrokerFilter = (props: any) => (
  <Filter {...props}>
    <TextInput alwaysOn label="Broker Name" source="name" />
    <TextInput alwaysOn label="MC Number" source="mc_number" />
    <SelectInput
      alwaysOn
      label="CloudTrucks LLC Status"
      source="cloudtrucks_llc_status"
      choices={BROKER_STATUS_CHOICES}
    />
    <SelectInput
      alwaysOn
      label="CT IN LLC Status"
      source="ct_in_llc_status"
      choices={BROKER_STATUS_CHOICES}
    />
    <TextInput label="FEIN Number" source="fein_number" />
    <BooleanInput label="Is Shipper" source="is_shipper" />
  </Filter>
)

const BrokerActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}: any) => {
  const { permissions } = usePermissions()
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      {permissions && hasPermission(permissions, Permissions.AddBroker) && (
        <BrokerQuickCreateButton onChange={() => {}} redirectToBrokerPage={true} />
      )}
    </TopToolbar>
  )
}

const BrokerList = (props: any) => {
  usePageTitle('Brokers')
  return (
    <CTList bulkActionButtons={false} filters={<BrokerFilter />} actions={<BrokerActions />} {...props}>
      <CTDatagrid optimized>
        <TextField source="name" />
        <TextField source="mc_number" />
        <TextField label="CloudTrucks LLC Status" source="cloudtrucks_llc_status" />
        <CustomBooleanField label="Carrier Setup" source="is_carrier_packet_complete" />
        <TextField source="support_main_phone" />
        <TextField source="support_main_email" />
        <TextField source="carrier_portal_link" />
        <TextField source="ct_in_llc_status" label="CT IN LLC Status" />
      </CTDatagrid>
    </CTList>
  )
}

export default BrokerList
